var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_89721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93023 12.4595H8.92589M7 12.4595C7 13.5645 7.84402 14.4595 8.88545 14.4595C9.73959 14.4595 10.4608 13.857 10.6929 13.031H12.7103C12.9135 13.031 12.926 13.044 12.926 13.2595V13.888C12.926 14.1575 12.926 14.292 13.0045 14.376C13.0834 14.4595 13.2105 14.4595 13.4643 14.4595H13.8307C14.0425 14.4595 14.148 14.4595 14.2226 14.3945C14.2967 14.33 14.3174 14.22 14.3593 14L14.5071 13.215C14.5404 13.039 14.5495 13.031 14.7185 13.031H15.0806C15.3343 13.031 15.4614 13.031 15.5404 12.947C15.7171 12.76 15.7002 11.8555 15.5404 11.686C15.4614 11.6025 15.3343 11.6025 15.0806 11.6025H10.5894C10.287 10.9265 9.63751 10.4595 8.88545 10.4595C7.84402 10.4595 7 11.3545 7 12.4595Z",
    stroke: "#244C84",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.12614C2.33333 3.94204 2.48257 3.79281 2.66667 3.79281H14C14.1841 3.79281 14.3333 3.94204 14.3333 4.12614V9.12614C14.3333 9.49433 14.6318 9.79281 15 9.79281C15.3682 9.79281 15.6667 9.49433 15.6667 9.12614V4.12614C15.6667 3.20566 14.9205 2.45947 14 2.45947H2.66667C1.74619 2.45947 1 3.20566 1 4.12614V12.7928C1 13.7133 1.74619 14.4595 2.66667 14.4595H5C5.36819 14.4595 5.66667 14.161 5.66667 13.7928C5.66667 13.4246 5.36819 13.1261 5 13.1261H2.66667C2.48257 13.1261 2.33333 12.9769 2.33333 12.7928V4.12614Z",
    fill: "#244C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 4.12598C1.6665 3.86076 1.77186 3.60641 1.9594 3.41887C2.14693 3.23133 2.40129 3.12598 2.6665 3.12598H13.9998C14.2651 3.12598 14.5194 3.23133 14.7069 3.41887C14.8945 3.60641 14.9998 3.86076 14.9998 4.12598V7.12598H1.6665V4.12598Z",
    stroke: "#244C84",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99967 5.1263C2.99967 4.75811 3.29815 4.45964 3.66634 4.45964C4.03453 4.45964 4.33301 4.75811 4.33301 5.1263C4.33301 5.49449 4.03453 5.79297 3.66634 5.79297C3.29815 5.79297 2.99967 5.49449 2.99967 5.1263Z",
    fill: "#244C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 5.1263C4.99967 4.75811 5.29815 4.45964 5.66634 4.45964C6.03453 4.45964 6.33301 4.75811 6.33301 5.1263C6.33301 5.49449 6.03453 5.79297 5.66634 5.79297C5.29815 5.79297 4.99967 5.49449 4.99967 5.1263Z",
    fill: "#244C84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_89721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333496 0.459473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptive);
export default __webpack_public_path__ + "static/media/Captive.e5b06efc8d33d589d55ad46b00b49f32.svg";
export { ForwardRef as ReactComponent };